import _regeneratorRuntime from "D:/work/code/aihuz/litigant-ui/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/code/aihuz/litigant-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
// import getPageTitle from '@/utils/get-page-title'
import defaultSettings from '@/settings';

//处理title
var title = defaultSettings.title;
function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(title);
  }
  return "".concat(title);
}
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/register', '/certify', '/certifying', '/protocol']; // no redirect whitelist

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(to, from, next) {
    var hasToken, hasGetUserInfo;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          title = localStorage.getItem('litigantTitle');
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken(); // if (store.getters.token) {
          if (hasToken && localStorage.getItem('token') && localStorage.getItem('name')) {
            if (to.path === '/login') {
              // if is logged in, redirect to the home page
              next({
                path: '/'
              });
              NProgress.done();
            } else {
              hasGetUserInfo = store.getters.name;
              if (hasGetUserInfo) {
                next();
              } else {
                try {
                  // get user info
                  // await store.dispatch('user/getInfo')

                  next();
                } catch (error) {
                  // remove token and go to login page to re-login
                  // await store.dispatch('user/resetToken')
                  Message.error(error || 'Has Error');
                  next("/login?redirect=".concat(to.path));
                  NProgress.done();
                }
              }
            }
          } else {
            /* has no token*/

            if (whiteList.indexOf(to.path) !== -1) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/login?redirect=".concat(to.path));
              NProgress.done();
            }
          }
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to, from, next) {
  if (to.path == '/login') {
    document.title = defaultSettings.title;
  }
  // finish progress bar
  NProgress.done();
});